export let colors = [
  'rgb(0, 0, 0)',
  'rgb(54, 35, 18)',
  'rgb(120, 79, 23)',
  'rgb(181, 63, 27)',
  'rgb(237, 34, 36)',
  'rgb(243, 91, 34)',
  'rgb(249, 150, 33)',
  'rgb(245, 193, 30)',
  'rgb(241, 235, 27)',
  'rgb(99, 199, 32)',
  'rgb(12, 155, 73)',
  'rgb(33, 135, 141)',
  'rgb(57, 84, 165)',
  'rgb(97, 55, 155)',
  'rgb(147, 40, 142)'
];

export let nameColors = 
  ['rgb(0,255,164)', 'rgb(166,104,255)']
;

